import { combineReducers } from 'redux';
import { initialLimitOrderMap } from 'state/secondaryMarket/limit-order/order/order.model';
import { amendTradeReducerFactory } from 'state/secondaryMarket/shared/amend/amend.reducer';
import { cancellationReducerFactory } from 'state/secondaryMarket/shared/cancellation/cancellation.reducer';
import { defaultReducerFactory } from 'state/secondaryMarket/shared/defaults/defaults.reducer';
import { kycReducerFactory } from 'state/secondaryMarket/shared/kyc/kyc.reducer';
import { orderReducerFactory } from 'state/secondaryMarket/shared/order/order.reducer';
import { removeKey } from 'state/utils/collection';

import { formReducer } from './form/form.reducer';
import type { LimitOrder } from './limitOrder.model';
import { limitOrderReferentialReducer } from './referential/referential.reducer';

export const limitOrderReducer = combineReducers<LimitOrder>({
  form: formReducer,
  amend: amendTradeReducerFactory('LIMIT_ORDER'),
  referential: limitOrderReferentialReducer,
  order: orderReducerFactory('LIMIT_ORDER', initialLimitOrderMap, (state, action) => {
    if (action.type === 'SECONDARY_MARKET_LIMIT_ORDER_CANCELED') {
      return removeKey(state, action.tabId);
    } else {
      return state;
    }
  }),
  defaults: defaultReducerFactory('LIMIT_ORDER'),
  cancellations: cancellationReducerFactory('LIMIT_ORDER'),
  kyc: kycReducerFactory('LIMIT_ORDER', 'limitOrder'),
});
